// extracted by mini-css-extract-plugin
module.exports = {"leadMagnetSuccess":"LeadMagnetSuccess_leadMagnetSuccess__JTnNO","thumbsIcon":"LeadMagnetSuccess_thumbsIcon__qxlrl","successMsg":"LeadMagnetSuccess_successMsg__GvYNm"};